// core/history — histori LENGKAP per transaksi (timeline ticket_logs awal→akhir). Canonical, dipakai lintas modul.
import { supabase } from '@core/supabase';
import { esc, dtLocal, linkifyNos } from '@domain/format';
import { openModal } from '@ui/modal';
import { toast } from '@ui/toast';

export interface HistoryLog { status: string; catatan: string | null; by_user: string | null; at: string }

/** Ambil seluruh log tiket (urut waktu). 0 baris = SAH (tiket tanpa log). */
export async function fetchTicketHistory(no: string): Promise<HistoryLog[]> {
  const { data, error } = await supabase().from('ticket_logs')
    .select('status,catatan,by_user,at').eq('ticket_no', no).order('at');
  if (error) throw new Error(error.message);
  return (data ?? []) as HistoryLog[];
}

/** Modal timeline histori lengkap 1 transaksi. Reusable dari mana pun (Laporan, Pembayaran, dll). */
export async function openTicketHistory(no: string): Promise<void> {
  let logs: HistoryLog[];
  try { logs = await fetchTicketHistory(no); } catch (e) { toast((e as Error).message); return; }
  // Setiap entri yang menyangkut REFUND/pengembalian dana → teks MERAH (permintaan Apo).
  const isRefundLog = (l: HistoryLog): boolean => /refund|pengembalian dana/i.test((l.status ?? '') + ' ' + (l.catatan ?? ''));
  const items = [...logs].reverse().map((l) => // terbaru di atas (Apo 19 Jul)
    `<div class="log-item"${isRefundLog(l) ? ' style="color:var(--danger)"' : ''}><b>${esc(l.status)}</b>${l.catatan ? ' — ' + linkifyNos(esc(l.catatan)) : ''}<div class="lt"${isRefundLog(l) ? ' style="color:var(--danger)"' : ''}>${esc(l.by_user ?? '—')} · ${dtLocal(l.at)}</div></div>`
  ).join('') || '<div class="empty">Belum ada histori.</div>';
  const bg = openModal(`<div class="modal-head"><h3>📜 Histori Lengkap — ${esc(no)}</h3><button class="x">×</button></div>
    <div class="modal-body">${items}</div>
    <div class="modal-foot"><button class="btn" id="h_close">Tutup</button></div>`);
  bg.querySelector('#h_close')?.addEventListener('click', () => bg.remove());
}
